import React from "react";
import { useSidebarPosition } from "../../../../router/context/SidebarPositionContext";

const SidebarPositionToggle = () => {
  const { position, setPosition } = useSidebarPosition();

  const baseBtnStyle = {
    padding: "4px 14px",
    border: "none",
    borderRadius: "999px",
    cursor: "pointer",
    fontSize: "12px",
    fontWeight: 600,
    transition: "background 0.2s, color 0.2s, box-shadow 0.2s",
    background: "transparent",
    color: "#495057",
    outline: "none",
    lineHeight: "1.4",
  };

  const activeBtnStyle = {
    ...baseBtnStyle,
    background: "#3a57e8",
    color: "#fff",
    boxShadow: "0 1px 4px rgba(58, 87, 232, 0.35)",
  };

  return (
    <div
      role="group"
      aria-label="Sidebar position toggle"
      style={{
        display: "inline-flex",
        alignItems: "center",
        padding: "3px",
        borderRadius: "999px",
        gap: "2px",
      }}
    >
      <button
        type="button"
        onClick={() => setPosition("left")}
        aria-pressed={position === "left"}
        style={position === "left" ? activeBtnStyle : baseBtnStyle}
      >
        Left
      </button>
      <button
        type="button"
        onClick={() => setPosition("right")}
        aria-pressed={position === "right"}
        style={position === "right" ? activeBtnStyle : baseBtnStyle}
      >
        Right
      </button>
    </div>
  );
};

export default SidebarPositionToggle;
